//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'
import { uppercaseFirst, uppercaseFirstLetter } from '@/server/utils/utils-string'
import { formatShortDate } from '@/server/utils/utils-date'
import { questionType } from '@/server/constants'

export default {
  name: 'QuestionAnswerItemOwner',
  props: {
    projectInReview: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => {}
    },
    questionNumber: {
      type: Number,
      default: 1
    },
    // Expand All / Collapse All, forwarded from CategoriesQuestions
    visible: {
      type: Boolean,
      default: false
    },
    toggleKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // collapsed by default; Expand All/Collapse All flips this via the
      // toggleKey watcher below, same as clicking the question does
      questionOpen: false,
      detailOpen: false,
      historyOpen: false,
      updateOpen: false
    }
  },
  watch: {
    // toggleKey always changes (even to force the same `visible` value twice),
    // so watch it rather than `visible` directly
    toggleKey() {
      this.questionOpen = this.visible
      if (!this.visible) {
        // mirrors toggleQuestion()'s reset when the question is closed manually
        this.detailOpen = false
        this.historyOpen = false
        this.updateOpen = false
      }
    }
  },
  computed: {
    ...mapGetters({
      getAnswerByQuestion: 'answers/getAnswerByQuestion',
      getFormattedAnswerByQuestion: 'answers/getFormattedAnswerByQuestion',
      getIsQuestionAnswered: 'answers/getIsQuestionAnswered',
      propertyIsEliminated: 'properties/getPropertyIsEliminated',
      unseenQuestions: 'questions/getUnseenQuestions'
    }),
    answerTypeLabel() {
      const { type } = this.question
      let label = null
      if (type === questionType.text) {
        label = 'Text'
      } else if (type === questionType.number) {
        label = 'Numeric'
      } else {
        label = 'Choice'
      }
      return label
    },
    displayAnswerHistory() {
      return Boolean(Object.keys(this.questionAnswer).length)
    },
    formattedAnswer() {
      return this.getFormattedAnswerByQuestion(this.question._id)
    },
    questionAnswer() {
      return this.getAnswerByQuestion(this.question._id)
    },
    answerIsRecalled() {
      return Boolean(this.questionAnswer?.recalled)
    },
    questionIsAnswered() {
      return this.getIsQuestionAnswered(this.question._id)
    },
    answerUnseen() {
      return this.unseenQuestions.some(q => String(q) === String(this.question._id))
    },
    lastUpdatedDate() {
      const updates = this.questionAnswer?.answerUpdates
      if (updates && updates.length > 0) {
        const lastUpdate = updates[updates.length - 1]
        return formatShortDate(lastUpdate.created)
      } else if (this.questionAnswer?.updated) {
        // const answer = this.getAnswerByQuestion(this.question._id)
        return formatShortDate(this.questionAnswer.updated)
      }
      return '-'
    }
  },
  mounted() {
    // Auto-clear the "not seen" indicator once the owner views the answer,
    // so marking it seen no longer requires an extra click.
    this.markRecordAsSeen()
  },
  methods: {
    ...mapActions({
      markQuestionAnswerAsSeen: 'questions/markQuestionAnswerAsSeen'
    }),
    toggleQuestion() {
      this.questionOpen = !this.questionOpen
      if (!this.questionOpen) {
        this.detailOpen = false
        this.historyOpen = false
        this.updateOpen = false
      }
    },
    formattedChoice(choice) {
      return uppercaseFirstLetter(choice)
    },
    async markRecordAsSeen() {
      if (this.questionIsAnswered && this.answerUnseen) {
        const answer = this.getAnswerByQuestion(this.question._id)
        // Ensure we have a valid answer with an _id before marking as seen
        if (answer && answer._id) {
          await this.markQuestionAnswerAsSeen({
            questionId: this.question._id,
            answerId: answer._id
          })
        }
      }
    }
  }
}
